export const config = {
  entraClientId: import.meta.env.VITE_ENTRA_CLIENT_ID ?? '',
  entraTenantId: import.meta.env.VITE_ENTRA_TENANT_ID ?? '',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api/v1',
  /** When true, skip MSAL and use X-Dev-User headers (local API only). */
  devAuth: import.meta.env.VITE_DEV_AUTH === 'true',
  redirectUri: import.meta.env.VITE_REDIRECT_URI ?? window.location.origin,
};

export const apiScope = config.entraClientId
  ? `api://${config.entraClientId}/Atlas.Access`
  : '';
